import script from "./CallControls.vue?vue&type=script&setup=true&lang=js"
export * from "./CallControls.vue?vue&type=script&setup=true&lang=js"

import "./CallControls.vue?vue&type=style&index=0&id=3f701fb8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f701fb8"]])

export default __exports__